import React, { useState } from "react";

const CreditApplicationForm = () => {
    const [formData, setFormData] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // console.log("Form Data Submitted:", formData);
        alert("Form submitted. Check console for data.");
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-4 p-4 max-w-3xl mx-auto">
            <h2 className="text-xl font-bold">Company Information</h2>

            <input name="company_name" placeholder="Full Name of Company" onChange={handleChange} className="w-full border p-2 rounded" />
            <input name="trading_name" placeholder="Trading Name" onChange={handleChange} className="w-full border p-2 rounded" />
            <input name="nature_of_business" placeholder="Nature of Business" onChange={handleChange} className="w-full border p-2 rounded" />
            <input name="abn" placeholder="ABN" onChange={handleChange} className="w-full border p-2 rounded" />

            <input name="delivery_address" placeholder="Delivery Address" onChange={handleChange} className="w-full border p-2 rounded" />
            <input name="delivery_postcode" placeholder="Delivery Postcode" onChange={handleChange} className="w-full border p-2 rounded" />
            <input name="postal_address" placeholder="Postal Address" onChange={handleChange} className="w-full border p-2 rounded" />
            <input name="postal_postcode" placeholder="Postal Postcode" onChange={handleChange} className="w-full border p-2 rounded" />

            <h3 className="text-lg font-semibold">Contact Details</h3>
            <input name="contact_email" placeholder="Contact Email" onChange={handleChange} className="w-full border p-2 rounded" />
            <input name="business_phone" placeholder="Business Phone" onChange={handleChange} className="w-full border p-2 rounded" />
            <input name="fax_number" placeholder="Fax Number" onChange={handleChange} className="w-full border p-2 rounded" />

            <h3 className="text-lg font-semibold">Procurement Contact</h3>
            <input name="procurement_name" placeholder="Name" onChange={handleChange} className="w-full border p-2 rounded" />
            <input name="procurement_email" placeholder="Email" onChange={handleChange} className="w-full border p-2 rounded" />
            <input name="procurement_title" placeholder="Title" onChange={handleChange} className="w-full border p-2 rounded" />
            <input name="procurement_direct_phone" placeholder="Direct Phone" onChange={handleChange} className="w-full border p-2 rounded" />
            <input name="procurement_mobile" placeholder="Mobile" onChange={handleChange} className="w-full border p-2 rounded" />

            <h3 className="text-lg font-semibold">Accounts Contact</h3>
            <input name="accounts_name" placeholder="Name" onChange={handleChange} className="w-full border p-2 rounded" />
            <input name="accounts_email" placeholder="Email" onChange={handleChange} className="w-full border p-2 rounded" />
            <input name="accounts_title" placeholder="Title" onChange={handleChange} className="w-full border p-2 rounded" />
            <input name="accounts_direct_phone" placeholder="Direct Phone" onChange={handleChange} className="w-full border p-2 rounded" />
            <input name="accounts_mobile" placeholder="Mobile" onChange={handleChange} className="w-full border p-2 rounded" />

            <h3 className="text-lg font-semibold">Directors / Proprietors</h3>
            <input name="director_name" placeholder="Name" onChange={handleChange} className="w-full border p-2 rounded" />
            <input name="director_address" placeholder="Address" onChange={handleChange} className="w-full border p-2 rounded" />
            <input type="date" name="director_dob" onChange={handleChange} className="w-full border p-2 rounded" />
            <input name="license_number" placeholder="Driver's License No." onChange={handleChange} className="w-full border p-2 rounded" />
            <input type="date" name="license_expiry" onChange={handleChange} className="w-full border p-2 rounded" />

            <h3 className="text-lg font-semibold">Trade References</h3>
            <input name="trade1_name" placeholder="Company 1 Name" onChange={handleChange} className="w-full border p-2 rounded" />
            <input name="trade1_email" placeholder="Email" onChange={handleChange} className="w-full border p-2 rounded" />
            <input name="trade1_address" placeholder="Address" onChange={handleChange} className="w-full border p-2 rounded" />
            <input name="trade1_phone" placeholder="Phone" onChange={handleChange} className="w-full border p-2 rounded" />

            <input type="number" name="credit_amount" placeholder="Amount of Credit Requested Monthly" onChange={handleChange} className="w-full border p-2 rounded" />

            <h3 className="text-lg font-semibold">Declaration</h3>
            <input name="guarantor_name1" placeholder="Name" onChange={handleChange} className="w-full border p-2 rounded" />
            <input name="signature1" placeholder="Signature" onChange={handleChange} className="w-full border p-2 rounded" />
            <input type="date" name="date1" onChange={handleChange} className="w-full border p-2 rounded" />

            <input name="guarantor_name2" placeholder="Name" onChange={handleChange} className="w-full border p-2 rounded" />
            <input name="signature2" placeholder="Signature" onChange={handleChange} className="w-full border p-2 rounded" />
            <input type="date" name="date2" onChange={handleChange} className="w-full border p-2 rounded" />

            <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded">Submit</button>
        </form>
    );
};

export default CreditApplicationForm;
